import { View, LinkView } from "@gaming/srvg-classes-core";

export class TextLinkView extends View {
    linkView: LinkView;

    link: string;
    text: string;
    translate: boolean;
    switch:string;
    constructor( options ) {
        options = options || {};
        super( options );

        this.link = options.link || "";
        this.text = options.text || "";
        this.translate = options.translate || true;
    }

    handleDomInstantiated() {
        if (!srvg.featuresInstances.getDisableGuiSwitchButton()) {
            this.linkView = this.addSubView( new LinkView( { template: app.templateEngine.template(LinkView)} ) );
            this.linkView.$domNode.click(function() {
                var event= this.href.indexOf('Vflm1') < 0?'switched default to retro':'switched retro to default';
            });
        }
        this.setText(this.text);
        this.setLink(this.link);
        super.handleDomInstantiated();
    }

    setOptions( options: any, fromConstructor?:boolean ) {
        if (options.text && this.text != options.text){
            this.setText(options.text);
            this.setLink(options.link);
        }
        super.setOptions(options, fromConstructor);
    }

    setText(text){
        if(this.linkView && this.linkView.setText){
            this.text = text;
            if (this.translate){
                this.text = __(this.text);
            }

            this.linkView.setText(this.text);
        }
    }

    setLink(link){
        if(this.linkView && this.linkView.setLink){
            this.text = link;
            this.linkView.setLink(this.link);
        }
    }
}